import { useMemo } from "react";
import { object, bool, string } from "yup";
import { AdminPublicite } from "src/domain/AdminPublicite";


const useValidationSchemaService = () => {
  const requiredMessage = "form.error.notEmpty";
  return useMemo(() => {

    // Schema représentant l'ensemble des champs du formulaire
    const validationSchema = object<AdminPublicite>().shape({
      id: string().nullable(),
      withIcone: bool().nullable(),
      flagNew: bool().nullable(),
      labelFr: string().required(requiredMessage),
      labelDe: string().required(requiredMessage),
      labelEn: string().required(requiredMessage),
      contenuHtmlFr: string().required(requiredMessage),
      contenuHtmlDe: string().required(requiredMessage),
      contenuHtmlEn: string().required(requiredMessage),
      agence: string().required(requiredMessage),

    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaService;
